

import React from 'react';
import ThankyouData from '../components/thankYou';
import usePageMeta from '../hooks/usePageMeta';
export default function ThankYouContact() {
    usePageMeta('Thank You for Contacting Our Team | Spinnennetz Agency', 'Thank you for reaching out! A Spinnennetz representative will be in touch with you shortly to discuss your project requirements and next steps in full detail.', '/thank-you-contact', {"@context":"https://schema.org","@type":"WebPage","name":"Thank You for Contacting Us"});
    return (
       <>
        <ThankyouData />
       </>
    )
}
